// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpButton, SpText } from 'components/DesignKit';

type Props = {
    paymentConfirmation: Object,
    setPaymentConfirmation: Function,
    onConfirm: Function,
    viewDetails: Object,
}

const PaymentConfirmation = (props: Props) => {
  const {
    paymentConfirmation, setPaymentConfirmation, onConfirm, viewDetails,
  } = props;
  const {
    prefix, overdueInterest, initialAmount, lateFee, graceDays, totalAmount, paymentDueDate,
  } = viewDetails;
  return (
    <Modal
      centered
      closable={false}
      visible={paymentConfirmation?.open}
      footer={[
        <SpButton onClick={() => { setPaymentConfirmation((prev) => ({ open: false, confirmation: false, method: prev?.value })); }} type="secondary">
          Cancel
        </SpButton>,
        <SpButton onClick={(e) => {
          setPaymentConfirmation((prev) => ({ open: false, confirmation: true, method: prev?.value }));
          onConfirm(e, paymentConfirmation?.method, 'PARTIAL');
        }}
        >
          Agree & Send
        </SpButton>,
      ]}
      title="Agreement"
    >
      <div className="px-4 pb-3">
        <div className="mt-1">
          Please be aware of the State Laws, where you operate your business, before finalizing ‘Late Fee’, ‘Interest if Overdue’, and ‘Grace Period’.
          Swirepay cannot be held liable for any disputes that occur between Merchant and Customer over the terms of the contract
        </div>
        <div className="d-flex flex-column mt-3">
          <div><SpText fontWeight="600">Initial Amount</SpText></div>
          <div className="mt-1">{prefix} {initialAmount}</div>
        </div>
        <div className="d-flex flex-column mt-2">
          <div><SpText fontWeight="600">Pending Amount</SpText></div>
          <div className="mt-1">
            {prefix} {(Number(totalAmount && totalAmount?.replace(/,/g, '')) - Number(initialAmount?.replace(/,/g, ''))).toFixed(2)}
          </div>
        </div>
        <div className="d-flex flex-column mt-2">
          <div><SpText fontWeight="600">Due Date</SpText></div>
          <div className="mt-1">{paymentDueDate}</div>
        </div>
        <div className="d-flex flex-column mt-2">
          <div><SpText fontWeight="600">Late Fee</SpText></div>
          <div className="mt-1">{lateFee ? `${prefix} ${lateFee}` : '-'}</div>
        </div>
        <div className="d-flex flex-column mt-2">
          <div><SpText fontWeight="600">Interest if Overdue:</SpText></div>
          <div className="mt-1">{overdueInterest ? `${overdueInterest}%` : '-'}</div>
        </div>
        <div className="d-flex flex-column mt-2">
          <div><SpText fontWeight="600">Grace Period</SpText></div>
          <div className="mt-1">{graceDays ? `${graceDays} Days` : '-'}</div>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentConfirmation;
